import { Outlet } from "react-router-dom";

export default function PublicQuizLayout() {
  return (
    <main className="min-h-screen bg-white flex flex-col">
      <section className="flex-1 flex flex-col">
        <Outlet />
      </section>
    </main>
  );
}
